import { Routes } from "@/router/routes";
import { RouteObject } from "react-router";
import { Users } from "./users";
import { InviteUser } from "./components/invite-user/invite-user";

export const usersRouterConfig: RouteObject[] = [
    {
        path: Routes.Users,
        element: <Users />,
        children: [
            {
                path: "invite",
                element: <InviteUser />,
            },
        ],
    },
];
